import { LitElementStateService } from '@stefanholzapfel/lit-state';
import {State} from "../views/loading/loading";

export class TranslateService {
    public static async init(language: Language): Promise<TranslateService> {
        if (!TranslateService.initialized) {
            await TranslateService.setLanguage(language);
            TranslateService.initialized = true;
            return TranslateService;
        } else {
            console.log('Already initialized TranslateService!');
        }
    }
    
    private static initialized = false;
    
    private static selectedLanguage: Language;
    private static loadedLanguages = new Map<Language, Object>();
    
    public static currentLanguage(): Language {
        return TranslateService.selectedLanguage;
    }
    
    private static async loadLanguage(language: Language): Promise<Object> {
        const langsResponse = await fetch('/assets/lang/' + language + '.json' );
        return await langsResponse.json();
    }
    
    public static async setLanguage(language: Language): Promise<Object> {
        if (!TranslateService.loadedLanguages.get(language)) {
            const langData = await TranslateService.loadLanguage(language);
            TranslateService.loadedLanguages.set(language, langData);
        }
        LitElementStateService.getGlobalInstance<State>().set({
            app: {
                language
            }
        })
        TranslateService.selectedLanguage = language;
        return TranslateService.loadedLanguages.get(language);
    }
    
    public static translate(translationString: string): string {
        if (translationString) {
            const path = translationString.split('.');
            let transString = TranslateService.loadedLanguages.get(TranslateService.selectedLanguage);
            for (const pathSegment of path) {
                if (transString && transString[pathSegment]) {
                    transString = transString[pathSegment];
                } else {
                    transString = translationString;
                    break;
                }
            }
            return transString as string;
        }
        return '';
    }
}

export type Language =
    'en-EN' |
    'de-DE';
